import Vue from 'vue'
import { clone, uniqid } from '@/js/utils'
import Medias from '@/js/medias'
import Sounds from '@/js/sounds'
import Musics from '@/js/musics'
import data_tutos from '@/data/data_tutos'



// === STATE =====================================================================================
const default_state = {
	zoom: 1,
	loaded: {
		images: false,
		sounds: false,
		musics: false	
	},
	shaking: null,
	popups: [],
	status_infos: [],
	tuto: null,
}
const state = clone(default_state)






// === GETTERS =====================================================================================
const getters = {
	app(state) { return state },
	app_ready(state) {
		return state.loaded.images && state.loaded.sounds && state.loaded.musics
	}
}







// === ACTIONS =====================================================================================
const actions = {

	async init_app({ commit, dispatch }) {
		// let start = Date.now()
		Medias.init()
		Sounds.init()
		Musics.init()
		dispatch('load_user')
		// console.info('app loaded in ' + (Date.now() - start) + 'ms')

		Musics.play('main')
	},

	trigger_tuto({ state, commit, rootGetters }, data) {
		if (!state.tuto) {
			const tuto = data_tutos.find(t => t.trigger === data.trigger && !rootGetters.user.viewed_tutos.includes(t.slug))
			if (tuto) {
				commit('EDIT_APP_STATE', { tuto })
			}
		}
	},

	add_popup({ state, commit }, data) {
		if (data) {
			Sounds.play('button')
			let popup = { ...data, id: uniqid() }
			commit('EDIT_APP_STATE', { popups: [ ...state.popups, popup ] })
		}
	},

	remove_popup({ state, commit }, data) {
		if (data.popup && data.popup.id) {
			if (!data.from || !(data.from === 'escape' && (data.popup.type === 'end-game' || data.popup.type === 'level-summary'))) {
				Sounds.play('button')
				commit('EDIT_APP_STATE', { popups: state.popups.filter((p) => p.id !== data.popup.id) })
			}
		}
	},

	add_status_info({ state, commit }, data) {
		if (data.status_info) {
			let status_info = { ...data.status_info, id: uniqid() }
			commit('EDIT_APP_STATE', { status_infos: [ ...state.status_infos, status_info ] })
		}
	},

	remove_status_info({ state, commit }, data) {
		if (data.status_info && data.status_info.id) {
			commit('EDIT_APP_STATE', { status_infos: state.status_infos.filter((p) => p.id !== data.status_info.id) })
		}
	}

}



// === MUTATIONS =====================================================================================
const mutations = {

	EDIT_APP_STATE(state, data) {
		for (var i in data) {
			Vue.set(state, i, data[i])
		}
	},

	SET_LOADED(state, data) {
		for (var i in data) {
			Vue.set(state.loaded, i, data[i])
		}
	}

}

export default { state, getters, actions, mutations }
